import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { ColorCodingDialog } from "./ColorCodingDialog";
import { EmployeeListItemDto } from "../../models/employee/employee";
import { getEmployees } from "../../services/employeeServiceNew";
import { useAppSelector } from "../../framework/customStore";
import { showApiError } from "../framework/formUtils";

export const ColorCodingDialogWrapper = () => {
    const history = useHistory();
    const [employees, setEmployees] = useState<EmployeeListItemDto[]>();

    const selectedEmployeeGroupId = useAppSelector(
        (state) => state.workShiftPlanning.filters.selectedEmployeeGroupId
    );

    useEffect(() => {
        getEmployees(selectedEmployeeGroupId)
            .then((res) => setEmployees(res?.data))
            .catch(showApiError);
    }, [selectedEmployeeGroupId]);

    return (
        <ColorCodingDialog
            open
            onClose={() => history.goBack()}
            employees={employees}
        />
    );
};